import CacheInstance from '../components/cache'

class SyncOneSignal {

  constructor () {

    this.cache = CacheInstance.get('one-signal');
    this.savedData = this.cache !== null ? this.cache.value : null;

  }

  maybeSyncOneSignal(data) {

    if(!window.isLoggedIn()) {
      return;
    }

    console.log('Updating One Signal');

    // first time syncing
    // or data has changed
    if(
      this.savedData === null ||
      JSON.stringify(this.savedData) !== JSON.stringify(data)
    ) {

      window.apiRequest('post', '/user/push-notifications', data).then(() => {

        CacheInstance.save('one-signal', data);
        console.log('Finished syncing One Signal');

      });

    }

  }

}

const SyncOneSignalInstance = new SyncOneSignal();

export default SyncOneSignalInstance;
